module.exports = __webpack_public_path__ + "a3f23c66484ce7da06e97f39e0b56025.jpg";